var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',{staticClass:"rounded-lg py-2",attrs:{"flat":"","height":"800px"}},[_c('div',{staticClass:"rowDiv contentCenter"},[_c('div',{staticClass:"rounded-lg ml-2 pageTitle",staticStyle:{"width":"200px"}},[_c('v-btn',{on:{"click":_vm.sendMessage}},[_vm._v("test")])],1),_c('v-spacer')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }